module.exports = __webpack_public_path__ + "img/right-q.4d286fae.png";